// ─── RSVP page-layout CSS builder ─────────────────────────────
// One source of truth for the scoped CSS overrides we inject on the
// dedicated RSVP page wrapper. Both the public route and the editor
// live-preview iframe call this so they always behave identically.
//
// Overrides supported:
//   • edge-to-edge: zero the section's horizontal padding so the
//     surface can reach the viewport edges on phones.
//   • top / bottom spacing: override the variant's baked-in py-20
//     (~80px) with a designer-chosen value (0..180px).
//
// Returns: { wrapperClass, css } — both empty strings when no
// override is active so existing pages render exactly as before.

export function buildPageLayoutCss({
  scopeClass,
  sectionSelector,
  edgeToEdge,
  topSpacing,
  bottomSpacing,
}) {
  const hasTop = typeof topSpacing === 'number';
  const hasBottom = typeof bottomSpacing === 'number';
  if (!edgeToEdge && !hasTop && !hasBottom) {
    return { wrapperClass: '', css: '' };
  }

  const rules = [];
  if (edgeToEdge) {
    rules.push('padding-left: 0 !important;');
    rules.push('padding-right: 0 !important;');
  }
  if (hasTop) rules.push(`padding-top: ${topSpacing}px !important;`);
  if (hasBottom) rules.push(`padding-bottom: ${bottomSpacing}px !important;`);

  const css = `.${scopeClass} ${sectionSelector} { ${rules.join(' ')} }`;
  return { wrapperClass: scopeClass, css };
}
